import { DEFAULT_EXPERIMENT_VALUES } from 'constants/experimentDefaults'
import React from 'react'
import { Box, Theme, Typography } from '@mui/material'

import { RMEResponse } from 'utils/api'
import PerformanceEstimate from './PerformanceEstimate'
import { ExperimentData } from './types'

interface RunInstructionProps {
  experimentData: ExperimentData
  metricsResult: RMEResponse | null
  isLoadingMetrics: boolean
  theme: Theme
}

const RunInstructions: React.FC<RunInstructionProps> = ({ experimentData, metricsResult, isLoadingMetrics, theme }) => {
  return (
    <Box>
      <Box sx={{
        backgroundColor: theme.palette.info.light,
        p: 2,
        borderRadius: 1,
        mb: 2,
        borderBottom: `1px solid ${'#d0d0d0'}`,
        height: '73px',
        display: 'flex',
        alignItems: 'center'
      }}>
        <Typography variant="h6" sx={{ fontWeight: 400, color: theme.palette.text.primary, fontSize: '18px',lineHeight:'20px' }}>
          Step 3: Run on REM-I Instrument
        </Typography>
      </Box>

      <Box sx={{ px: 1 }}>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 400, fontSize: '16px',lineHeight:'20px' }}>
            {experimentData.experimentGoal === 'imaging'  ?  'In Run Setup, use these settings:' :'In Run Setup, use these settings:'}
          </Typography>
          <Box sx={{ ml: 2 }}>
            <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 400, fontSize: '16px',lineHeight:'20px' }}>
              1. Target Cell Throughput: <Box component="span" sx={{ fontWeight: 700 }}>{Math.round(metricsResult?.cell_rate_per_second ?? DEFAULT_EXPERIMENT_VALUES.DEFAULT_CELL_RATE_FALLBACK)} cells / s</Box>
            </Typography>
            {(experimentData.experimentGoal === 'purity' || experimentData.experimentGoal === 'yield') && (
              <>
                <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 400, fontSize: '16px',lineHeight:'20px' }}>
                  2. Sorting Mode: <Box component="span" sx={{ fontWeight: 700 }}>Serial Sort</Box>
                </Typography>
                <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 400, fontSize: '16px',lineHeight:'20px' }}>
                  3. Sorting Option: <Box component="span" sx={{ fontWeight: 700 }}>{experimentData.experimentGoal === 'purity' ? 'High Purity' : 'High Yield'}</Box>
                </Typography>
              </>
            )}
          </Box>
        </Box>

        <PerformanceEstimate experimentData={experimentData} metricsResult={metricsResult} isLoadingMetrics={isLoadingMetrics} theme={theme} />
      </Box>
    </Box>
  )
}

export default RunInstructions
